import React from "react";
import "./WeatherInfo.css";
import FormattedDate from "./FormattedDate";

export default function WeatherInfo (props) {
    return (
        <div className="WeatherInfo">
            <div className="col-8 MainSummary">
            <h1>{props.data.city}, {props.data.country}</h1>
                <ul>
                    <li><FormattedDate date={props.data.date} /></li>
                    <li>Humdiity: {props.data.humidity}%</li>
                    <li>Wind: {props.data.wind} km/h</li>
                </ul>
            </div>
            <div className="col-4 MainTemp" >
            <img className="WeatherIcon" src={props.data.icon} alt={props.data.description}/>
            <h2>{props.data.temperature}</h2><p className="metric">°C</p>
              
            </div>
        </div>
    )
}
 